import React from 'react'

import {getUserLocation} from '../../common/get-user-location'

import GiftContext from '../../../context/context'
import Field from '../../common/field'
import PhoneField from '../../common/phone-field/PhoneField'
import UIRadio from '../../common/uiRadio/UIRadio'
import ClassicCheckbox from '../../common/classic-checkbox'
import {order as expenses, entities as expensesEntities} from './flightsExpenses/config/expenses'

export default class FormRegistration extends React.Component {
    static contextType = GiftContext
    state = {
        currentCard: '',
        errorCard: false
    }
    handleClubCard = (val) => {
        this.setState({currentCard: val})
    }
    founderCardValidate = () => {
        if (this.state.currentCard.length < 10 || !this.state.currentCard.startsWith('1030')) {
            this.setState({errorCard: true})
        } else {
            this.setState({errorCard: false})
        }
    }
    hermitageCardValidate = () => {
        if (this.state.currentCard.length === 4 && !isNaN(this.state.currentCard)) {
            this.setState({errorCard: false})
        } else {
            this.setState({errorCard: true})
        }
    }

    render() {
        const {country} = getUserLocation()
        const {code} = this.props
        return (
            <GiftContext.Consumer>
                {({formContent, formData, handleChangeField, renderError}) => (
                    <div className="form-state --registration">
                        <div className="form-field field-name">
                            <Field
                                label={formContent.texts.name}
                                name="name"
                                type="text"
                                value={formData.name}
                                hasError={renderError('name')}
                                onChange={handleChangeField}
                            />
                        </div>
                        <div className="form-field field-email">
                            <Field
                                label={formContent.texts.email}
                                name="email"
                                type="text"
                                value={formData.email}
                                hasError={
                                    renderError('email') ||
                                    renderError('email.notvalid') ||
                                    renderError('email.exists')
                                }
                                onChange={handleChangeField}
                            />
                        </div>
                        <div className="form-field field-password">
                            <Field
                                label={formContent.texts.password}
                                name="password"
                                type="password"
                                value={formData.password}
                                hasError={renderError('password') || renderError('password.tooshort')}
                                onChange={handleChangeField}
                            />
                        </div>
                        <div className="form-field field-rpassword">
                            <Field
                                label={formContent.texts.passwordConfirm}
                                name="rpassword"
                                type="password"
                                value={formData.rpassword}
                                hasError={renderError('rpassword') || renderError('rpassword.nonmatch')}
                                onChange={handleChangeField}
                            />
                        </div>
                        <div className="form-field field-phone">
                            <div
                                className={`phone-input ${
                                    formData.errors.includes('phone.notvalid') ? 'error' : ''
                                }`}
                            >
                                <PhoneField
                                    className="integrated"
                                    name="phone"
                                    country={country || 'us'}
                                    value={formData.phone}
                                    onChange={handleChangeField}
                                />
                            </div>
                            <div className="field-error">{renderError('phone.notvalid')}</div>
                        </div>
                        {['FOUNDERSCARD-2021'].includes(code) ?
                            <div className="form-field field-name">
                                    <br/><br/>
                                    <input
                                        style={{width: '100%'}}
                                        placeholder="FoundersCard email"
                                        name="founders"
                                        type="text"
                                        onBlur={this.founderCardValidate}
                                        maxLength={30}
                                        value={this.state.currentCard}
                                        onChange={e => this.handleClubCard(e.target.value)}
                                    />
                                {this.state.errorCard ? <div className="field-error">Invalid email</div> : null}
                            </div>
                            : null}
                        {['HERMITAGE-2021'].includes(code) ?
                            <div className="form-field field-name">
                                <br/><br/>
                                <input
                                    style={{width: '100%'}}
                                    placeholder="The Hermitage Club"
                                    name="hermitage"
                                    type="text"
                                    onBlur={this.hermitageCardValidate}
                                    maxLength={4}
                                    value={this.state.currentCard}
                                    onChange={e => this.handleClubCard(e.target.value)}
                                />
                                {this.state.errorCard ? <div className="field-error">Invalid card number</div> : null}
                            </div>
                            : null}
                        <div className="survey-wrapper">
                            <div className="form-field field-flown">
                                <div className="form-checkbox">
                                        <ClassicCheckbox
                                            id="flownBefore"
                                            name="flownBefore"
                                            checked={formData.flownBefore === true}
                                            onChange={() => handleChangeField('flownBefore', !formData.flownBefore)}
                                        />
                                    <p className="checkbox-text" style={{color: '#393B41'}}>
                                        {formContent.texts.flownBefore}
                                    </p>
                                </div>
                                <div className="field-error">{renderError('flownBefore')}</div>
                            </div>
                            <div className={`field-switcher ${formData.flownBefore ? '--switched' : ''}`}>
                                <div className="flights-expenses">
                                    <div className="form-radio --column">
                                        <p className="radio-text --full" style={{color: '#393B41'}}>
                                            {formContent.texts.headers.flightsExpenses}
                                        </p>
                                        {expenses.map((key) => {
                                            const entity = expensesEntities[key]
                                            return (
                                                <UIRadio
                                                    key={key}
                                                    name="flights-expenses"
                                                    value={key}
                                                    isBig
                                                    className="flights-expenses__toggle"
                                                    checked={formData.amountSpent === entity.serverValue}
                                                    onChange={() => handleChangeField('amountSpent', entity.serverValue)}
                                                >
                                                    {entity.getName(formData.lang)}
                                                </UIRadio>
                                            )
                                        })}
                                        <div className="field-error error-survey">{renderError('survey')}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      <div className="form-field form-checkbox form-mb-16">
                        <ClassicCheckbox
                          id="privacyPolicy"
                          name="privacyPolicy"
                          checked={formData.privacyPolicy}
                          onChange={() => handleChangeField('privacyPolicy', !formData.privacyPolicy)}
                        />
                        <p className="checkbox-text" style={{color: '#393B41'}}>
                          {formContent.agreements}
                        </p>
                      </div>
                      {formData.errors.some((error) => ['privacyPolicy'].includes(error)) ? (
                        <p  style={{marginBottom: '10px'}} className="error-message">{formContent.texts.termsErr}</p>
                      ) : null}
                      <div className="form-field form-checkbox form-mb-16">
                        <ClassicCheckbox
                          id="privacyPolicy2"
                          name="privacyPolicy2"
                          checked={formData.privacyPolicy2}
                          onChange={() => handleChangeField('privacyPolicy2', !formData.privacyPolicy2)}
                        />
                        <p className="checkbox-text" style={{color: '#393B41'}}>
                          {formContent.agreements2}
                        </p>
                      </div>
                      {formData.errors.some((error) => ['privacyPolicy2'].includes(error)) ? (
                        <p style={{marginBottom: '10px'}} className="error-message">{formContent.texts.termsErr2}</p>
                      ) : null}
                    </div>
                )}
            </GiftContext.Consumer>
        )
    }
}
